export default __webpack_public_path__ + "static/media/uploader-animas-2.e343d01a.png";